// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Dgq","rootMobile":"styles_rootMobile__3CUOH"};